import './featured-image.scss';
